import throttle from 'lodash-es/throttle';

import http from '@/utils/http';

export enum Code {
  TaxCode = 'taxCode',
  Eic = 'eic',
  // TODO rename to eicGasSupplyStation
  EicGasSupplyStation = 'eicGasDistributionStation',
}

// The EIC is the shared RBAC's check, the other codes are BMS's own (billing-organizations, GSB-8317).
const endpoints = {
  [Code.TaxCode]: 'billing-organizations/tax-code',
  [Code.Eic]: 'organizations/eic',
  [Code.EicGasSupplyStation]: 'billing-organizations/eic-gas-supply-station',
};

export const validateCodeFn = (key: Code) =>
  throttle(async (value: string) => {
    try {
      const {
        data: { isValid },
      } = await http({
        url: `/${endpoints[key]}/validate?${key}=${value}`,
      });
      return isValid;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (err) {
      return false;
    }
  }, 1500);
